// SSP-specific Stimulus controllers; the generic ones are registered by platform_ui
import LiveInputFieldController from '../view_components/live_input_field/live_input_field'
window.Stimulus.register('live-input', LiveInputFieldController)

import LiveStringInputFieldController from '../view_components/live_string_input_field/live_string_input_field'
window.Stimulus.register('live-string-input', LiveStringInputFieldController)

import DirtyFilterFormController from './controllers/dirty_filter_form_controller'
window.Stimulus.register('dirty-filter-form', DirtyFilterFormController)
